import { render, staticRenderFns } from "./manage-link-layout.vue?vue&type=template&id=c8868398"
import script from "./manage-link-layout.vue?vue&type=script&lang=js"
export * from "./manage-link-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports